import * as React from "react";
import { forwardRef } from "react";
const SvgCameraVideo = (props, ref) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("rect", { x: 1, y: 5, width: 17, height: 14, rx: 1, fill: "currentColor" }), /* @__PURE__ */ React.createElement("path", { d: "M18 9l5-3v12l-5-3z", fill: "currentColor" }));
const ForwardRef = forwardRef(SvgCameraVideo);
export default ForwardRef;
